
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
            Editar registro
          </h4>
        </template>
        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución
                        </label>
                        <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <template>
                                <vs-option v-for="option in institucionesArray" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select filter :loading="loadingSelect" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar">
                            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                Requerido
                            </template>
                            <template v-if="ciclosEscolares.length">
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label class="labelInput">Código de detalle a subcategorizar</label>
                        <vs-select filter :loading="loadingSelect" class="pt-0" placeholder="Seleccionar código de detalle a subcategorizar" v-model="codigo" :key="codigoId">
                            <template #message-danger v-if="errorFields.includes('codigo')">
                                Requerido
                            </template>
                            <vs-option v-for="(option, i) in codigosDetalle" :key="i" :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label class="labelInput">Categoría</label>
                        <vs-input class="pt-0" v-model="categoria" placeholder="Categoría">
                            <template #message-danger v-if="errorFields.includes('categoria')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
            </vs-row>
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="getEditarSubcategorias()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
        'value',
        'selectInfo',
        'institucionesArray',
        'ciclosEscolaresArray',
        'codigosDetalle'
    ],
    data:() => ({
        active: false,
        errorFields: [],
        institucion: '',
        institucionId: (new Date()).getTime(),
        cicloEscolar: '',
        ciclosEscolares: [],
        cicloId: (new Date()).getTime(),
        codigo: '',
        codigoId: (new Date()).getTime(),
        categoria: '',
        loadingSelect: false
    }),
    methods: {
        async getCicloEscolar() {
            this.loadingSelect = true
            const { data: response } = await academico.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
            this.loadingSelect = false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion){
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar){
                this.errorFields.push('cicloEscolar')
            }
            if (!this.codigo){
                this.errorFields.push('codigo')
            }
            if (!this.categoria){
                this.errorFields.push('categoria')
            }
            if (!this.errorFields.length){
                const params = {
                    "subcategoria_id": this.selectInfo.subcategoria_id,
                    "institucion_id":  this.institucion,
                    "ciclo_escolar_id":  this.cicloEscolar,
                    "codigo_detalle_id":  this.codigo,
                    "nombre":  this.categoria
                    
                 }
                return params
            } else {
                return null
            }
        },
        async getEditarSubcategorias(){
            const payload = this.sanityForm()
            if(payload){
                const loading = this.$vs.loading()
                try{
                    const { data: response } = await academico.getEditarSubcategorias(payload)
                    loading.close()
                    this.active = false
                this.$emit('refreshTable')
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se ha modificado con éxito el registro.'
                    })
                }catch{
                    loading.close()
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salió mal.',
                        text: 'Póngase en contacto con el administrador.'
                    })
                }
            }
        },
        getInfo(){
            this.institucion = this.selectInfo.institucion_id
            this.cicloEscolar = this.selectInfo.ciclo_escolar_id
            this.categoria = this.selectInfo.nombre
            this.codigo = this.selectInfo.codigo_detalle_id
        },
    },
    watch:{
      value (val) {
          this.active = val
      },
      async active (val) {
          if (!val){
              this.$emit('input', val);
          }
      },
      institucion(){
          this.getCicloEscolar()
      },
      selectInfo(){
          this.getInfo()
      }
    }
}
</script>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>